<template>
    <div class="text-center error">
        <div class="fas fa-bomb"></div>
        <h1>Unfortunately we`ve encountered some problem</h1>
        <h2>Please try again, later!</h2>
    </div>
</template>
<style scroped>
    .error{
        color: #cecece;
        font-size: 10rem;
    }
</style>
